import { render, staticRenderFns } from "./geography.vue?vue&type=template&id=26d941e7&"
import script from "./geography.vue?vue&type=script&lang=js&"
export * from "./geography.vue?vue&type=script&lang=js&"
import style0 from "./geography.vue?vue&type=style&index=0&id=26d941e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports